import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider";
import {
  initialise,
  createAdobeSource,
  createEventBusSource,
  createAdobeDTMSink,
  createGtmSink,
  createOptimizelySink
} from "@asosteam/asos-web-event-tracking-bridge";
import { eventBus } from "@src/helpers/eventing/events";
import { GTM_ID } from "./constants";
import { noticeError } from "@src/helpers/monitoring";
import { asosGlobalNamespace, sdkGlobalNamespace } from "@template/constants";
import { isProd } from "@src/helpers/isProd";

const initialiseEventTrackingBridge = () => {
  const featuresDelegate = sdkInstanceProvider("features");
  const { s: adobeDelegate } = window;

  const identitySdk = window[asosGlobalNamespace][sdkGlobalNamespace].identity;

  return initialise({
    sources: {
      adobe: createAdobeSource(adobeDelegate),
      eventBus: createEventBusSource(eventBus)
    },
    sinks: {
      adobeDTM: createAdobeDTMSink(isProd()),
      gtm: createGtmSink(GTM_ID, noticeError),
      optimizely: createOptimizelySink(featuresDelegate)
    },
    config: {
      logError: noticeError,
      getIdTokenClaimsAsync: identitySdk.getIdTokenClaimsAsync,
      isAuthenticated: identitySdk.customer.isAuthenticated
    }
  });
};

export default initialiseEventTrackingBridge;
